// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"0d686180","589":"78b87e69","899":"47bbf329"}[chunkId] + ".chunk.css";
};